// extracted by mini-css-extract-plugin
export default {"term":"Fee-module__term","tokenIcon":"Fee-module__tokenIcon"};